module.exports = __webpack_public_path__ + "img/easymeet_icon.0c4b9175.svg";